import { render, staticRenderFns } from "./AgendamentoEnviarTokenEmailForm.vue?vue&type=template&id=47e3a261&scoped=true&style=v-application&"
import script from "./AgendamentoEnviarTokenEmailForm.vue?vue&type=script&lang=js&"
export * from "./AgendamentoEnviarTokenEmailForm.vue?vue&type=script&lang=js&"
import style0 from "./AgendamentoEnviarTokenEmailForm.vue?vue&type=style&index=0&id=47e3a261&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e3a261",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCard,VCol,VFlex,VForm,VIcon,VRow,VSpacer,VTextField})
